type Brand = 'klaro' | 'aisha';
type Environment = 'development' | 'staging' | 'production';

interface BrandConfig {
  brand: Brand;
  brandName: string;
  environment: Environment;
  primaryColor: string;
  primaryColorHover: string;
  activeNavColor: string;
  faviconSvg: string;
}

const brand = (import.meta.env.VITE_BRAND as Brand) || 'klaro';
const environment = (import.meta.env.VITE_ENVIRONMENT as Environment) || 'development';

const brands: Record<Brand, Omit<BrandConfig, 'brand' | 'environment'>> = {
  klaro: {
    brandName: 'Klaro AI',
    primaryColor: '#B45309',
    primaryColorHover: '#92400E',
    activeNavColor: '#B45309',
    faviconSvg: '/favicons/klaro.svg',
  },
  aisha: {
    brandName: 'Aisha',
    primaryColor: '#B45309',
    primaryColorHover: '#92400E',
    activeNavColor: '#B45309',
    faviconSvg: '/favicons/aisha.svg',
  },
};

export const brandConfig: BrandConfig = {
  brand,
  environment,
  ...(brands[brand] ?? brands.klaro),
};

export function getEnvironmentLabel(): string | null {
  if (brandConfig.environment === 'production') return null;
  return brandConfig.environment;
}

export function getPageTitle(): string {
  const env = getEnvironmentLabel();
  const suffix = env ? ` (${env})` : '';
  return `${brandConfig.brandName} Admin${suffix}`;
}
